import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GiftcardsAddedGiftcardComponentDef } from '@df/module-giftcards/giftcards-added-giftcard.component.def';
import { DfUiModule } from '@df/ui/df-ui.module';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from '../ui/api/action.component';
import { ResultComponent } from '../ui/resut/result.component';
@Component({
    selector: 'giftcards-added-giftcard',
    templateUrl: './giftcards-added-giftcard.html',
    standalone: true,
    imports: [TranslationModule, DfUiModule, PriceComponent, ActionComponent, ResultComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftcardsAddedGiftcardComponent extends GiftcardsAddedGiftcardComponentDef {
    get lastFour(): string {
        const code = this.giftcard?.code;
        if (code) {
            return '...' + code.substr(code.length - 4);
        }
        return '';
    }
    get value(): number {
        return this.giftcard?.amount;
    }
}
